import React from "react";
import useDate from "../../../../../../hooks/app/useDate";
import TextEllipsis from "../../../../../text/TextEllipsis";
import ElementsFromTo from "./ElementsFromTo";
import IconTooltipButton from "../../../../../button/IconTooltipButton";

const LogCardMax = ({
  id,
  log = {},
  lc = {},
  currentCurriculum = {},
  onRemove,
  onClick,
  showChange = true,
}) => {
  const { formatDate } = useDate();
  return (
    <div
      className="border border-muted rounded py-4 px-4 relative"
      onClick={onClick}
    >
      <div className="absolute top-0 right-0 ">
        {onRemove && (
          <IconTooltipButton
            id={`button-remove-${id}`}
            icon={["fal", "times"]}
            onClick={() => onRemove(log._id)}
            title="Remove"
            className="bg-background"
            color="primary"
            style={{
              backgroundColor: "var(--background)",
            }}
          />
        )}
      </div>
      {Object.keys(lc?.lcElements || {}).map((key) => (
        <TextEllipsis
          key={key}
          className=" text-primary font-bold"
          children={lc?.lcElements[key]}
        />
      ))}
      <p className="text-sm font-bold text-secondary mt-2">
        Changes: {showChange ? "" : log?.from?.length}
      </p>
      {showChange && (
        <ElementsFromTo
          currentCurriculum={currentCurriculum}
          granularSteps={lc.granularSteps}
          from={log.from}
          to={log.to}
          type={"max"}
        />
      )}
      {log.notes && (
        <div className="flex gap-2 justify-end ">
          {log.notes?.filter((note) => note.date)?.map((note) => {
            const level = currentCurriculum?.levels?.find(
              (level) => level._id === note.levelId
            );
            const marking = currentCurriculum?.marking?.find(
              (marking) => marking._id === note.completed
            );
            return (
              <div
                key={`log-${id}--notes-${note?.ulId}`}
                className="border border-muted rounded py-2 px-2 max-w-150px min-w-150px"
              >
                <TextEllipsis
                  className=" text-primary font-bold"
                  children={note?.ulName}
                />
                <div className="grid grid-cols-2 gap-2 py-2 item-center justify-center text-muted-foreground opacity-75">
                  <span className="text-2xs uppercase text-right font-bold">
                    Max level marked:{" "}
                  </span>
                  <span className="text-sm ">{level?.name || note?.levelId}</span>
                  <div className="flex justify-end">
                    <span
                      style={{
                        height: 15,
                        width: 15,
                        backgroundColor: marking?.primaryColor,
                      }}
                      className={[
                        "rounded text-right",
                        marking?.primaryColor ? "" : " bg-lines ",
                      ].join(" ")}
                    />
                  </div>
                    <span className="text-sm ">
                      {marking?.name || note?.completed}
                    </span>
                </div>
                <div className="text-right text-muted-foreground opacity-75 mt-2">
                  <span className="text-xs ">Marked on </span>
                  <b className="text-xs ">
                    {note?.date ? formatDate(note?.date) : ""}
                  </b>{" "}
                  <span className="text-xs ">by </span>{" "}
                  <b className="text-xs ">{note?.userName || note?.userCode}</b>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="text-right text-muted-foreground opacity-75 mt-2">
        <span className="text-xs ">Marked on </span>
        <b className="text-xs ">{formatDate(log?.date)}</b>{" "}
        <span className="text-xs ">
          {log.type === "close" ? "closed " : ""} by{" "}
        </span>{" "}
        <b className="text-xs ">{log?.userName || log?.userCode}</b>
      </div>
    </div>
  );
};

export default LogCardMax;
